<template>
  <div class="beyond-compare-promotion-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
          <img src="../assets/beyondcompare_logo.png" class="logo-icon" alt="Beyond Compare Logo">
          <span class="logo-text">BEYOND COMPARE</span>
        </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/beyond-compare" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="main-banner">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <div id="comment-container" class="animate">
              <img src="../assets/beyond-compare-preview.png" alt="Beyond Compare 预览图" class="hero-image">
               <!-- <div id="comment1" class="styledfont">改变不可避免，所以用最好的工具来管理它。</div> -->
              <!-- <div id="comment2" class="styledfont">所以用最好的工具来管理它。</div>  -->
              <div id="comment1" ><strong>Beyond Compare</strong> 是一款强大专业的文件和文件夹对比工具。使用它可以很方便地比较出两个文件或文件夹的差异，相差的每一个字节用颜色加以标识，让您查看方便，支持众多种格式的对比。</div>
            </div>
            <el-button type="primary" size="large" class="cta-btn download-speed-btn" @click="downloadBeyondCompare">
              <el-icon><Download /></el-icon>
              <span class="btn-text">立即下载 Beyond Compare</span>
              <!-- <span class="speed-indicator">
                <span class="speed-dot"></span>
                <span class="speed-dot"></span>
                <span class="speed-dot"></span>
              </span> -->
            </el-button>
            <div class="download-counter">
              <span class="counter-label">累计下载 </span>
              <span class="counter-number">{{ downloadCount.toLocaleString() }}</span>
              <span class="counter-label">次</span>
              <span class="counter-animation" :class="{ 'animate': isAnimating }">+1</span>
            </div>
            <div class="system-requirements">
              <img src="../assets/Windows.png" alt="Windows">
              <span>支持系统：Windows 7/8/10/11</span>
            </div>
            <div class="download-benefits-info">
              <el-icon color="#409EFF"><Lightning /></el-icon>
              <span>一键安装</span>
              <el-icon color="#E6A23C"><Star /></el-icon>
              <span>永久使用</span>
              <el-icon color="#67C23A"><Refresh /></el-icon>
              <span>持续更新</span>
            </div>
          </div>
          <img src="../assets/shot_TextCompare_Dark_2.png" alt="Beyond Compare 预览图" class="hero-image-big">
        </div>
      </div>
    </div>

    <!-- Feature Block -->
    <div class="featureblock">
      <div class="container">
        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 1: File Comparison -->
          <div class="panel thirds impact">
            <h2><img src="../assets/home_compare.png" style="height: 50px; vertical-align: middle; margin-right: 10px;">精准的文件对比</h2>
            <p>Beyond Compare 可以对文本文件进行详细的逐行比较，高亮显示差异部分。支持语法高亮，便于程序员快速识别代码变更。可直接编辑文件内容并实时同步到对比结果中。</p>
            <div class="text-center">
              <img src="../assets/shot_TextMerge_Dark.png" alt="Beyond Compare 文本对比" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <!-- Feature 2: Folder Comparison -->
          <div class="panel thirds impact">
            <h2><img src="../assets/home_merge.png" style="height: 50px; vertical-align: middle; margin-right: 10px;">智能文件夹对比</h2>
            <p>Beyond Compare 能够快速比较两个文件夹的内容，通过颜色标识新增、删除和修改的文件。支持过滤规则，只显示感兴趣的文件类型，忽略临时文件和无关内容。</p>
            <div class="text-center">
              <img src="../assets/bc_folder_compare.png" alt="Beyond Compare 文件夹对比" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <!-- Feature 3: Merge Functionality -->
          <div class="panel thirds impact">
            <h2><img src="../assets/home_sync.png" style="height: 50px; vertical-align: middle; margin-right: 10px;">智能合并功能</h2>
            <p>Beyond Compare 提供强大的三向合并功能，可以轻松解决文件冲突。支持自动合并无冲突部分，对于存在冲突的部分提供直观的操作界面，让用户手动选择保留哪些变更。</p>
            <div class="text-center">
              <img src="../assets/bc_merge.png" alt="Beyond Compare 合并功能" style="max-width: 100%; height: auto;">
            </div>
          </div>
        </div>

        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 4: Table Comparison -->
          <div class="panel thirds impact">
            <h2>表格数据对比</h2>
            <p>Beyond Compare 支持 Excel、CSV 等表格文件的对比，能够识别行列变化并高亮显示数据差异。支持按列进行排序和筛选，快速找到关键数据变更。</p>
            <div class="text-center">
              <img src="../assets/bc_table_compare.png" alt="Beyond Compare 表格对比" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <!-- Feature 5: Image Comparison -->
          <div class="panel thirds impact">
            <h2>可视化图片对比</h2>
            <p>Beyond Compare 提供多种图片对比模式，包括并排视图、覆盖视图和混合视图。支持像素级差异检测，高亮显示图片变化区域，是设计师和摄影师的理想工具。</p>
            <div class="text-center">
              <img src="../assets/bc_image_compare.png" alt="Beyond Compare 图片对比" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <!-- Feature 6: FTP Support -->
          <div class="panel thirds impact">
            <h2>FTP 文件对比</h2>
            <p>Beyond Compare 内置 FTP 浏览器，可以直接连接到远程服务器进行文件对比。支持多种协议包括 FTP、FTPS 和 SFTP，安全传输文件并实时比较本地与服务器端的差异。</p>
            <div class="text-center">
              <img src="../assets/bc_ftp_compare.png" alt="Beyond Compare FTP 对比" style="max-width: 100%; height: auto;">
            </div>
          </div>
        </div>

        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 7: Report Generation -->
          <div class="panel thirds impact">
            <h2>报告生成</h2>
            <p>Beyond Compare 可以将对比结果导出为 HTML、Excel 或文本格式的报告，便于分享和存档。支持自定义报告模板，满足不同场景下的汇报需求。</p>
            <div class="text-center">
              <img src="../assets/bc_report.png" alt="Beyond Compare 报告生成" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <!-- Feature 8: Customizable Interface -->
          <div class="panel thirds impact">
            <h2>可定制的界面</h2>
            <p>Beyond Compare 提供丰富的界面自定义选项，可以根据个人喜好调整布局、颜色主题和快捷键设置。支持多标签页操作，同时处理多个对比任务。</p>
            <div class="text-center">
              <img src="../assets/bc_customize.png" alt="Beyond Compare 界面定制" style="max-width: 100%; height: auto;">
            </div>
          </div>

          <div class="panel thirds impact">
            <h2>为什么选择 Beyond Compare?</h2>
            <p>Beyond Compare 是专业、可靠的数据对比工具，被全球数百万用户信赖。无论是程序员、系统管理员还是普通用户，都能从中受益。立即下载体验，提升您的工作效率！</p>
            <div class="text-center">
              <el-button type="primary" size="large" class="cta-btn download-speed-btn" @click="downloadBeyondCompare">
                <el-icon><Download /></el-icon>
                <span class="btn-text">立即下载 Beyond Compare</span>
              </el-button>
              <div class="system-requirements">
                <span>支持系统：Windows 7/8/10/11</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 用户评价版块 -->
    <div class="reviews-section">
      <div class="container">
        <h2>用户评价</h2>
        <p class="section-subtitle">来自全球用户的真实好评</p>
        <div class="reviews-grid">
          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">👨‍💻</div>
                <div class="reviewer-name">张程序员</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"代码合并再也不头疼了！Beyond Compare 能快速找出分支间的差异，三向合并功能特别实用。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">👩‍💼</div>
                <div class="reviewer-name">李经理</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"团队文档版本管理神器，每次更新都能清楚看到改动内容，大大减少了沟通成本。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">🧑‍🎨</div>
                <div class="reviewer-name">王设计师</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"图片对比功能很强大，能一眼看出设计稿的修改点，和客户确认变更时特别方便。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">📚</div>
                <div class="reviewer-name">陈老师</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"用了 5 年 Beyond Compare，处理学生作业和论文差异从未如此轻松。值得每个教育工作者拥有！"</p>
          </div>
        </div>
        <div class="review-stats">
          <div class="stat-item">
            <div class="stat-number">300万+</div>
            <div class="stat-label">全球用户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">4.9★</div>
            <div class="stat-label">平均评分</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">99%</div>
            <div class="stat-label">推荐率</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中间 CTA 按钮区域 -->
    <div class="middle-cta-section">
      <div class="container">
        <h2>立即体验高效对比</h2>
        <p>加入 300 万全球用户的行列，享受 5 倍效率提升</p>
        <div class="cta-buttons">
          <el-button type="primary" size="large" class="cta-btn" @click="downloadBeyondCompare">
            <el-icon><Download /></el-icon>
            立即免费下载
          </el-button>
          <el-button type="default" size="large" class="cta-btn-secondary" @click="scrollToFeatures">
            了解更多功能
          </el-button>
        </div>
      </div>
    </div>

    <!-- Awards Section -->
    <div class="awardsblock">
      <div class="container">
        <h2>Beyond Compare 奖项</h2>
        <div class="awards main_page">
          <div class="award">
            <div class="awardimg"><img src="../assets/bc_cnet_top_rated.gif" alt="CNet 顶级评分 Beyond Compare 奖项"></div>
            <p class="subtext">CNet<br>顶级评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/bc_softpedia.gif" alt="Softpedia Beyond Compare 奖项"></div>
            <p class="subtext">Softpedia<br>5/5 评分</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/bc_cnet_popular.gif" alt="CNet 最受欢迎 Beyond Compare 奖项"></div>
            <p class="subtext">CNet<br>最受欢迎</p>
          </div>
          <div class="award">
            <div class="awardimg"><img src="../assets/bc_editor_choice.gif" alt="编辑推荐 Beyond Compare 奖项"></div>
            <p class="subtext">编辑推荐<br>年度工具</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Try Free Section -->
    <div class="earnmoney tryforfreeblock">
      <div class="container">
        <h2>立即下载 Beyond Compare</h2>
        <p>工作效率翻倍！Beyond Compare 支持多种格式对比 + 智能合并功能，是开发者、设计师和办公人员必备工具！</p>
        <el-button type="primary" size="large" class="cta-btn" @click="downloadBeyondCompare">
          <el-icon><Download /></el-icon>
          立即下载 Beyond Compare
        </el-button>
        <br><br>
        <div class="subtext">
          <img src="../assets/os.png" alt="Beyond Compare 系统支持"><br>
          支持系统：Windows 7/8/10/11, macOS 10.14+, Linux
        </div>
      </div>
    </div>
    
    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <!-- <div class="qrcode-container">
            <img src="../assets/wechat.png" alt="企业微信二维码" class="qrcode-img">
          </div> -->
          <div class="service-info">
            <!-- <p>企业微信</p> -->
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击联系客服
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <div class="footer-main">
          <p class="copyright">Copyright©2025 信阳市平桥区奇安科技有限公司贵州分公司 黔ICP备2026000902号</p>
          <div class="footer-links">
            <a href="/#/beyond-compare" class="footer-link">隐私政策</a>
            <span class="separator">|</span>
            <a href="/#/beyond-compare" class="footer-link">用户协议</a>
            <span class="separator">|</span>
            <a href="/#/about" class="footer-link">联系我们</a>
          </div>
        </div>
        <div class="footer-disclaimer">
          <p><strong>免责声明：</strong>本网站的图文和软件资源来源于网络。若任何内容侵犯您的合法权益，请立即<a href="mailto:softdown51@outlook.com" class="disclaimer-link">与我们联系</a>，我们会在 24 小时内核实并删除。</p>
          <!-- <p class="legal-note">本站所有软件信息仅供参考，用户需自行承担使用风险。任何因使用本站资源产生的问题，本站概不负责。</p> -->
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Download,
  Service,
  Lightning,
  Star,
  Refresh
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/beyond-compare') {
    return '/beyond-compare'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/beyond-compare') {
    router.push('/beyond-compare')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}


// 滚动到功能区域
const scrollToFeatures = () => {
  const featureBlock = document.querySelector('.featureblock')
  if (featureBlock) {
    featureBlock.scrollIntoView({ behavior: 'smooth' })
  }
}

// 下载 Beyond Compare
const downloadBeyondCompare = () => {
  // 模拟下载计数增加
  simulateDownload()
  
  // 发送Umami自定义事件 - Beyond Compare下载
  if (window.umami) {
    window.umami.track('download-beyond-compare', {
      type: 'software',
      name: 'Beyond Compare',
      version: 'latest',
      url: 'https://file.51softdown.cn/download/beyond-compare/BCompare-zh-5.1.6-Setup.exe'
    });
  }
  
  // 实际的下载逻辑
  window.open('https://file.51softdown.cn/download/beyond-compare/BCompare-zh-5.1.6-Setup.exe', '_blank');
}

// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

// 下载计数器相关
const downloadCount = ref(128547) // 初始下载数
const isAnimating = ref(false)

// 模拟下载数增加
const simulateDownload = () => {
  const increment = Math.floor(Math.random() * 3) + 1 // 随机增加1-3次
  isAnimating.value = true
  
  // 动画效果
  setTimeout(() => {
    isAnimating.value = false
  }, 1000)
  
  // 增加下载数
  downloadCount.value += increment
}

// 定期模拟下载（每3-8秒随机增加）
const startDownloadSimulation = () => {
  const randomInterval = Math.floor(Math.random() * 5000) + 3000 // 3-8秒随机间隔
  setTimeout(() => {
    simulateDownload()
    startDownloadSimulation() // 递归调用，持续模拟
  }, randomInterval)
}

// 组件挂载时设置页面标题和 favicon
import { onMounted } from 'vue'

onMounted(() => {
  // 设置页面标题和 favicon
  document.title = 'Beyond Compare - 专业文件对比工具'
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/beyond-compare.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/beyond-compare.ico'
    document.head.appendChild(favicon)
  }
  
  // 启动下载数模拟
  startDownloadSimulation()
  
  // 触发 hero 文字动画
  setTimeout(() => {
    const commentContainer = document.getElementById('comment-container');
    if (commentContainer) {
      commentContainer.classList.add('animate');
      const divs = commentContainer.querySelectorAll('div');
      divs.forEach(div => {
        div.style.opacity = '1';
      });
    }
  }, 100);
})
</script>

<style scoped>
.beyond-compare-promotion-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #333;
  background: linear-gradient(135deg, #3F414B, #3F414B);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* Panel Styles */
.panel-container {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: space-between;
}

.panel {
  flex: 1;
  min-width: 300px;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.panel:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

.thirds {
  flex-basis: calc(33.333% - 20px);
}

.text-center {
  text-align: center;
  margin-top: 15px;
}

.panel h2 {
  color: #1890ff;
  margin-bottom: 15px;
  font-size: 20px;
}

.panel p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* Hero Section */
.main-banner {
  padding: 60px 0;
  background: linear-gradient(135deg, #e3f2fd 0%, #d4d4d4 50%, #a0a0a0 100%);
  color: #333;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.main-banner .container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 30px;
}

.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
  padding: 40px 20px;
}

.hero-image {
  max-width: 500px;
  height: auto;
  border-radius: 12px;
  /* box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2); */
  flex: 1;
  min-width: 300px;
}

.hero-image-big {
  max-width: 780px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  flex: 1;
  min-width: 600px;
}

.hero-text {
  flex: 1;
  min-width: 560px;
  text-align: left;
  padding: 20px 0;
}

.main-banner h1 {
  font-size: 2.8rem;
  margin-bottom: 25px;
  font-weight: 800;
  line-height: 1.2;
}

.main-banner .lead {
  font-size: 1.3rem;
  margin-bottom: 35px;
  line-height: 1.6;
  opacity: 0.95;
}

/* Beyond Compare Hero Text Animation */
#comment-container {
  position: relative;
  margin-top: 20px;
  width: 100%;
  z-index: 10;
}

#comment-container div {
  margin: 0 0px;
  color: #333;
}

#comment-container.animate div {
  opacity: 0;
}

.styledfont {
  font-size: 1.8rem;
  font-weight: bold;
  line-height: 1.6em;
  text-shadow: 2px -2px 5px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
  text-align: left;
}

#comment1 {
  padding-top: 20px;
  transition: opacity 1s;
  font-size: 1.5rem;
}

#comment2 {
  transition: opacity 2s;
  transition-delay: 1s;
}

#comment3 {
  padding: 30px 0 0 0;
  transition: opacity 3s;
  transition-delay: 2s;
  font-size: 1.3rem;
  line-height: 1.6em;
  max-width: 500px;
  margin: 0 auto;
  color: #2c3e50;
  font-weight: 500;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(248, 250, 252, 0.9));
  border-radius: 12px;
  padding: 25px 30px;
  /* box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08); */
  backdrop-filter: blur(10px);
  /* border: 1px solid rgba(255, 255, 255, 0.2); */
  position: relative;
  overflow: hidden;
}

#comment3::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #1890ff, #40a9ff, #36cfc9);
  animation: shimmer 3s ease-in-out infinite;
}

#comment3::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  animation: shine 4s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% {
    opacity: 0.5;
    transform: scaleX(0.8);
  }
  50% {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes shine {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

#comment3:hover {
  transform: translateY(-2px);
  /* box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12); */
  transition: all 0.3s ease;
}

.main-banner .cta-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border-radius: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 1;
  padding: 28px 36px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(24, 144, 255, 0.3);
  margin-top: 30px;
  margin-bottom: 20px;
}

.hero-text {
  flex: 1;
  min-width: 300px;
  text-align: left;
  padding: 20px 0;
}

.main-banner .cta-btn:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);
}


.system-requirements {
  display: block;
  text-align: left;
  margin-top: 15px;
  font-size: 14px;
  align-items: left;
  justify-content: left;
  color: #666;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: 60px;
}

/* 下载计数器样式 */
.download-counter {
  text-align: left;
  margin-bottom: 10px;
  margin-top: 20px;
  margin-left: 60px;
}

.counter-number {
  font-size: 24px;
  font-weight: bold;
  color: #1890ff;
  margin-right: 8px;
}

.counter-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

.counter-animation {
  display: inline-block;
  color: #52c41a;
  font-weight: bold;
  font-size: 18px;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.5s ease;
}

.counter-animation.active {
  opacity: 1;
  transform: translateY(0);
}

.download-security-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 36px;
  gap: 10px;
  margin-top: 15px;
  margin-left: 0;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.download-security-info span {
  margin-right: 15px;
}

.download-security-info span:last-child {
  margin-right: 0;
}

.download-benefits-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 36px;
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.download-benefits-info span {
  margin-right: 15px;
}

.download-benefits-info span:last-child {
  margin-right: 0;
}

/* 下载速度动效 */
@keyframes speedFlow {
  0% {
    opacity: 0;
    transform: translateX(-10px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateX(20px);
  }
}

@keyframes pulse-scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.system-requirements {
  display: flex;
  align-items: center;
  text-align: left;
  margin-left: 60px;
  margin-top: 15px;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.system-requirements img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  vertical-align: middle;
}

.download-speed-btn {
  position: relative;
  overflow: hidden;
}

.download-speed-btn:hover .speed-indicator {
  opacity: 1;
  visibility: visible;
}

.speed-indicator {
  display: flex;
  gap: 6px;
  margin-left: 8px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.speed-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  animation: speedFlow 1.2s ease-in-out infinite;
}

.speed-dot:nth-child(1) {
  animation-delay: 0s;
}

.speed-dot:nth-child(2) {
  animation-delay: 0.3s;
}

.speed-dot:nth-child(3) {
  animation-delay: 0.6s;
}

.btn-text {
  position: relative;
}

.download-speed-btn:active {
  animation: pulse-scale 0.4s ease;
}

/* Feature Block */
.featureblock {
  padding: 80px 0;
}

.featureblock .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.featureblock .row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 60px;
  align-items: center;
}

.featureblock .row:nth-child(even) {
  flex-direction: row-reverse;
}

.featureblock .col {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.featureblock .col.content-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.featureblock h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  color: #333;
  font-weight: 700;
}

.featureblock p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
  margin-bottom: 20px;
}

.featureblock .content-img img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.featureblock .img2, .featureblock .img3 {
  display: none;
}

.featureblock .subtext {
  font-size: 0.9rem;
  color: #999;
  margin-top: 10px;
}

/* 上段按钮区域 */
.middle-cta-section {
  padding: 80px 0;
  background: linear-gradient(135deg, rgba(31, 179, 147, 0.1) 0%, rgba(24, 144, 255, 0.1) 100%);
  text-align: center;
}

.middle-cta-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.middle-cta-section h2 {
  font-size: 2rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: 700;
}

.middle-cta-section p {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.cta-btn-secondary {
  background-color: white;
  border: 2px solid #1890ff;
  color: #1890ff;
  font-weight: 600;
  padding: 16px 36px;
  border-radius: 30px;
  font-size: 16px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.cta-btn-secondary:hover {
  background-color: #f0fdf4;
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(64, 169, 255, 0.2);
}

/* 用户评价版块 */
.reviews-section {
  padding: 80px 0;
  background: white;
}

.reviews-section .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.reviews-section h2 {
  font-size: 2rem;
  margin-bottom: 15px;
  color: #333;
  font-weight: 700;
  text-align: center;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #666;
  text-align: center;
  margin-bottom: 50px;
}

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.review-card {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 12px;
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
}

.review-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
  background: white;
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewer-avatar {
  font-size: 32px;
  line-height: 1;
}

.reviewer-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.review-stars {
  color: #ffc107;
  font-size: 16px;
  letter-spacing: 2px;
}

.review-text {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #666;
  font-style: italic;
  margin: 0;
}

.review-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
  padding: 40px 0;
  border-top: 2px solid #f0f0f0;
  border-bottom: 2px solid #f0f0f0;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1890ff;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
}

/* Section Styles */
.section {
  padding: 80px 0;
}

.section.center {
  text-align: center;
  background: #f8f9fa;
}

.section.center .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.cta-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 18px 30px;
  border: none;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
}

.cta-btn:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.cta-btn2 {
  background-color: transparent;
  border-radius: 25px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 1;
  padding: 15px 30px;
  border: 2px solid #1FB393;
  color: #1FB393;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 10px;
}

.cta-btn2:hover {
  background-color: #f0fdf4;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Try Free Block */
.earnmoney {
  padding: 80px 0;
  background: linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%);
  color: white;
  text-align: center;
}

.earnmoney h2 {
  font-size: 2rem;
  margin-bottom: 20px;
  font-weight: 700;
}

.earnmoney p {
  font-size: 1.1rem;
  margin-bottom: 30px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
}

.earnmoney .subtext {
  font-size: 0.9rem;
  margin-top: 20px;
  opacity: 0.8;
}

.earnmoney .subtext img {
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.tryforfreeblock {
  background: #f8f9fa;
  color: #333;
}

/* New Version Section */
.newversion {
  padding: 80px 0;
  background: white;
}

.newversion .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.newversion .row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.newversion .col {
  flex: 1;
  min-width: 300px;
  padding: 0 20px;
}

.newversion .img2 {
  display: none;
}

.newversion .tag {
  background: #1FB393;
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 20px;
}

.newversion p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 20px;
}

/* Awards Block */
.awardsblock {
  padding: 80px 0;
  background: #f8f9fa;
  text-align: center;
}

.awardsblock .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.awardsblock h2 {
  font-size: 2rem;
  margin-bottom: 40px;
  color: #333;
  font-weight: 700;
}

.awards.main_page {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
}

.award {
  flex: 1;
  min-width: 150px;
  max-width: 200px;
}

.awardimg {
  margin-bottom: 15px;
}

.awardimg img {
  max-width: 100%;
  height: auto;
}

.award .subtext {
  font-size: 0.9rem;
  color: #666;
}

.link-btn {
  color: #1890ff;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.link-btn:hover {
  color: #40a9ff;
  text-decoration: underline;
}

/* 客服联系方式 */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.service-toggle {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  padding: 12px 16px;
  border-radius: 10px 0 0 10px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 24px rgba(24, 144, 255, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #1890ff;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.qrcode-container {
  text-align: center;
  margin-bottom: 15px;
}

.qrcode-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #40a9ff;
}

/* Footer */
.footer {
  background: #333;
  color: #999;
  padding: 50px 0;
  text-align: center;
  max-width: 100%;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  background: #333;
  max-width: 100%;
}

.footer-main {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright {
  margin-bottom: 15px;
  font-size: 13px;
  color: #999;
  letter-spacing: 0.5px;
}

.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.footer-link {
  font-size: 13px;
  color: #999;
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

.footer-link:hover {
  color: #fff;
}

.separator {
  color: #555;
  font-size: 12px;
}

.footer-disclaimer {
  text-align: left;
  max-width: 900px;
  margin: 0 auto;
}

.footer-disclaimer p {
  margin: 12px 0;
  font-size: 12px;
  line-height: 1.6;
  color: #999;
}

.footer-disclaimer strong {
  color: #bbb;
  font-weight: 600;
}

.disclaimer-link {
  color: #1FB393;
  text-decoration: none;
  transition: color 0.3s ease;
}

.disclaimer-link:hover {
  color: #20c9a6;
  text-decoration: underline;
}

.legal-note {
  color: #777 !important;
  font-size: 11px !important;
  margin-top: 15px;
}

/* Responsive */
@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .main-banner h1 {
    font-size: 2rem;
  }
  
  .main-banner .lead {
    font-size: 1rem;
  }
  
  .featureblock .row {
    flex-direction: column !important;
  }
  
  .featureblock .col {
    padding: 20px 0;
  }
  
  .featureblock .col.content-img {
    order: -1;
  }
  
  .awards.main_page {
    gap: 15px;
  }
  
  .award {
    min-width: 120px;
    max-width: 150px;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
}
</style>